import { SecurityStatus } from '../api/octopus';

export enum DuplicateCheckOptions {
  RuleFullNameCompanyName = 'Full Name/Company Name',
  RuleCityTown = 'City/Town',
  RuleStateProvince = 'State/Province',
  RuleZipPostalCode = 'Zip/Postal Code',
  RuleCompanyNameForIndividual = 'Company Name For Individual',
  RuleAllPhoneNumbers = 'All Phone Numbers',
  RuleAllEmailAddresses = 'All Email Addresses',
}

export interface DuplicateCheck {
  key?: string;
  isEnabled: boolean;
  userCanDuplicate?: boolean;
  rules?: string[];
  secStatus?: SecurityStatus;
}

export interface DuplicatedEntry {
  key: string;
  displayValue: string;
  type: string;
  title: string;
}
